import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * One narrative "move" the user made in a message, as graded by the expression
 * assessor.
 * @since 1.0.0
 */
export const AssessedMoveSchema = Schema.Struct({
  move: Schema.String, // narrative move name
  intensity: Schema.String, // graded word, e.g. "warm"
  evidence: Schema.String, // quoted user text
});

/**
 * The full per-message expression assessment payload, stored as JSONB since it
 * is always read/written as a unit.
 * @since 1.0.0
 */
export const ExpressionAssessmentPayloadSchema = Schema.Struct({
  moves: Schema.Array(AssessedMoveSchema),
  fit: Schema.Struct({
    invited: Schema.String,
    met: Schema.Literal("yes", "partial", "no"),
    why: Schema.String,
  }),
  triggerIntersections: Schema.Array(Schema.Struct({
    triggerKey: Schema.String,
    activated: Schema.Boolean,
    why: Schema.String,
  })),
  conversationDelta: Schema.String,
});

export type AssessedMove = Schema.Schema.Type<typeof AssessedMoveSchema>;
export type ExpressionAssessmentPayload = Schema.Schema.Type<typeof ExpressionAssessmentPayloadSchema>;

/**
 * Expression assessment model: one graded assessment per user message linking a
 * conversation, the message, and the assessor payload.
 * @since 1.0.0
 */
export class ExpressionAssessment extends Model.Class<ExpressionAssessment>("ExpressionAssessment")({
  id: Model.Generated(Schema.String),
  conversationId: Schema.String,
  messageId: Schema.String,
  payload: ExpressionAssessmentPayloadSchema,
  createdAt: Model.DateTimeInsertFromDate,
}) {}
